import styled from 'styled-components';

import { RouterLink } from '@redux-first-router-link';

export const CompanyLink = styled(RouterLink)`
  text-decoration: unset;
  color: unset;
  display: flex;
`;
